<kendo-grid
  #grid
  *ngIf="state"
  [style.minHeight.px]="minHeight"
  [style.minWidth.px]="minWidth"
  [style.maxHeight.px]="maxHeight"
  [style.maxWidth.px]="maxWidth"
  size="small"
  class="grid-container"
  [loading]="isLoading"
  [pageSize]="state.take"
  [skip]="state.skip"
  [sort]="state.sort"
  (dataStateChange)="onDataStateChange($event)"
  [pageable]="paginate ? pagerSettings : paginate"
  [data]="dataItems"
  [reorderable]="true"
  [filterable]="filterable"
  [selectable]="selectable"
  [resizable]="true"
  [sortable]="true"
  (filterChange)="onFilterChange($event)"
  [filter]="state.filter"
  [group]="group"
  [groupable]="groupable"
  (selectionChange)="onSelectRow($event)"
  [rowClass]="rowCallback"
  [scrollable]="scrollable"
  #gridRef
>
  <ng-template *ngIf="toolbarTemplate" kendoGridToolbarTemplate position="top">
    <ng-container
      *ngTemplateOutlet="toolbarTemplate; context: { columns: columns }"
    ></ng-container>

    <kendo-toolbar-spacer></kendo-toolbar-spacer>
  </ng-template>
  <ng-container *ngIf="!hideCommands">
    <kendo-grid-command-column
      *ngFor="
        let commandColumn of commandColumnTemplates
          | toArray
          | filter: 'align' : 'start'
      "
      class="command-column"
      [width]="commandColumn.width"
    >
      <ng-template kendoGridCellTemplate let-dataItem="dataItem">
        <ng-container
          *ngTemplateOutlet="
            commandColumn.template;
            context: { $implicit: dataItem }
          "
        ></ng-container>
      </ng-template>
    </kendo-grid-command-column>
  </ng-container>
  <ng-container *ngFor="let column of columns">
    <kendo-grid-column
      [editable]="column.editable ?? false"
      [filterable]="column.filterable ?? false"
      [title]="column.title"
      [field]="column.field"
      [sortable]="column.sortable ?? false"
      [width]="column.width ? (column.width * fontSize) / defaultFontSize : -1"
      [hidden]="
        (column.hidden ?? false) ||
        (isQuickView && !column.visibleInQuickView) ||
        (!isQuickView && !(column.visibleInDetailsView ?? true))
      "
      [headerClass]="column.headerClass || ''"
      [class]="column.class || ''"
      [headerStyle]="headerStyle"
    >
      <ng-template
        *ngIf="column.headerTemplate"
        kendoGridHeaderTemplate
        let-gridColumn="column"
        let-columnIndex="columnIndex"
      >
        <ng-container
          *ngTemplateOutlet="
            column.headerTemplate;
            context: { column: column, columnIndex: columnIndex }
          "
        ></ng-container>
      </ng-template>

      <ng-template kendoGridGroupHeaderTemplate let-group="group">
        <ng-container
          *ngIf="column.groupHeaderTemplate; else defaultGroupHeader"
        >
          <ng-container
            *ngTemplateOutlet="
              column.groupHeaderTemplate;
              context: { group: group, column: column }
            "
          ></ng-container>
        </ng-container>
        <ng-template #defaultGroupHeader>
          {{ group.value }}
        </ng-template>
      </ng-template>
      <ng-template
        kendoGridFilterMenuTemplate
        *ngIf="column.filterable"
        let-filter
        let-gridColumn="column"
        let-filterService="filterService"
      >
        <app-filter-menu
          [filter]="filter"
          [column]="column"
          [filterService]="filterService"
          [gridColumn]="gridColumn"
          (customFilterChange)="
            onCustomFilterChange(
              $event.column,
              $event.filter,
              $event.filterService
            )
          "
        ></app-filter-menu>
      </ng-template>

      <ng-template
        kendoGridFilterCellTemplate
        let-filter
        let-gridColumn="column"
      >
        <app-filter-cell
          [column]="column"
          [filter]="filter"
          [gridColumn]="gridColumn"
        ></app-filter-cell>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem="dataItem">
        <span>
          <ng-container *ngIf="column.columnTemplate; else plainColumn">
            <ng-container
              *ngTemplateOutlet="
                column.columnTemplate;
                context: { column: column, row: dataItem }
              "
            ></ng-container>
          </ng-container>

          <ng-template #plainColumn>
            <div *ngIf="!column.editable || dataItem.locked || mode == 'view'">
              <app-column
                [fontSize]="fontSize"
                [column]="column"
                [data]="dataItem"
              ></app-column>

              <span *ngIf="dataItem.errors?.has(column.field)" kendoTooltip>
                <fa-icon
                  [title]="dataItem.errors?.get(column.field)"
                  class="error"
                  [icon]="['fas', 'exclamation-circle']"
                ></fa-icon>
              </span>
            </div>

            <div
              class="grid-column k-d-flex k-justify-content-between"
              [style.textAlign]="column.align || 'center'"
              *ngIf="column.editable && !dataItem.locked && mode == 'edit'"
            >
              <app-editable-column
                [fontSize]="fontSize"
                [dataItem]="dataItem"
                [column]="column"
                (valueChange)="onValueChange($event.dataItem, $event.field)"
              ></app-editable-column>
            </div>
          </ng-template>
        </span>
      </ng-template>
    </kendo-grid-column>
  </ng-container>

  <ng-container *ngIf="columnGroups">
    <ng-container *ngFor="let group of columnGroups">
      <kendo-grid-column-group
        [title]="group.title"
        [headerClass]="group.headerClass || ''"
        [headerStyle]="headerStyle"
      >
        <ng-container *ngFor="let column of group.columns">
          <kendo-grid-column
            [editable]="column.editable ?? false"
            [filterable]="column.filterable ?? false"
            [title]="column.title"
            [field]="column.field"
            [sortable]="column.sortable ?? false"
            [width]="
              column.width ? (column.width * fontSize) / defaultFontSize : -1
            "
            [hidden]="
              (column.hidden ?? false) ||
              (isQuickView && !column.visibleInQuickView) ||
              (!isQuickView && !(column.visibleInDetailsView ?? true))
            "
            [headerStyle]="headerStyle"
            [headerClass]="column.headerClass || ''"
            [class]="column.class || ''"
          >
            <ng-template
              *ngIf="column.headerTemplate"
              kendoGridHeaderTemplate
              let-gridColumn="column"
              let-columnIndex="columnIndex"
            >
              <ng-container
                *ngTemplateOutlet="
                  column.headerTemplate;
                  context: { column: column, columnIndex: columnIndex }
                "
              ></ng-container>
            </ng-template>

            <ng-template kendoGridGroupHeaderTemplate let-group="group">
              <ng-container
                *ngIf="column.groupHeaderTemplate; else defaultGroupHeader"
              >
                <ng-container
                  *ngTemplateOutlet="
                    column.groupHeaderTemplate;
                    context: { group: group, column: column }
                  "
                ></ng-container>
              </ng-container>
              <ng-template #defaultGroupHeader>
                {{ group.value }}
              </ng-template>
            </ng-template>
            <ng-template
              kendoGridFilterMenuTemplate
              *ngIf="column.filterable"
              let-filter
              let-gridColumn="column"
              let-filterService="filterService"
            >
              <app-filter-menu
                [filter]="filter"
                [column]="column"
                [filterService]="filterService"
                [gridColumn]="gridColumn"
                (customFilterChange)="
                  onCustomFilterChange(
                    $event.column,
                    $event.filter,
                    $event.filterService
                  )
                "
              ></app-filter-menu>
            </ng-template>

            <ng-template
              kendoGridFilterCellTemplate
              let-filter
              let-gridColumn="column"
            >
              <app-filter-cell
                [column]="column"
                [filter]="filter"
                [gridColumn]="gridColumn"
              ></app-filter-cell>
            </ng-template>

            <ng-template kendoGridCellTemplate let-dataItem="dataItem">
              <span>
                <ng-container *ngIf="column.columnTemplate; else plainColumn">
                  <ng-container
                    *ngTemplateOutlet="
                      column.columnTemplate;
                      context: { column: column, row: dataItem }
                    "
                  ></ng-container>
                </ng-container>

                <ng-template #plainColumn>
                  <div
                    *ngIf="
                      !column.editable || dataItem.locked || mode == 'view'
                    "
                  >
                    <app-column
                      [fontSize]="fontSize"
                      [column]="column"
                      [data]="dataItem"
                    ></app-column>

                    <span
                      *ngIf="dataItem.errors?.has(column.field)"
                      kendoTooltip
                    >
                      <fa-icon
                        [title]="dataItem.errors?.get(column.field)"
                        class="error"
                        [icon]="['fas', 'exclamation-circle']"
                      ></fa-icon>
                    </span>
                  </div>

                  <div
                    class="grid-column k-d-flex k-justify-content-between"
                    [style.textAlign]="column.align || 'center'"
                    *ngIf="
                      column.editable && !dataItem.locked && mode == 'edit'
                    "
                  >
                    <app-editable-column
                      [fontSize]="fontSize"
                      [dataItem]="dataItem"
                      [column]="column"
                      (valueChange)="
                        onValueChange($event.dataItem, $event.field)
                      "
                    ></app-editable-column>
                  </div>
                </ng-template>
              </span>
            </ng-template>
          </kendo-grid-column>
        </ng-container>
      </kendo-grid-column-group>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="!hideCommands">
    <kendo-grid-command-column
      *ngFor="
        let commandColumn of commandColumnTemplates
          | toArray
          | filter: 'align' : 'end'
      "
      class="command-column"
      [width]="commandColumn.width"
      [title]="commandColumn.title || ''"
    >
      <ng-template kendoGridCellTemplate let-dataItem="dataItem">
        <ng-container
          *ngTemplateOutlet="
            commandColumn.template;
            context: { $implicit: dataItem }
          "
        ></ng-container>
      </ng-template>
    </kendo-grid-command-column>
  </ng-container>

  <ng-template *ngIf="noRecordsTemplate" kendoGridNoRecordsTemplate>
    <h4>
      <ng-container
        *ngTemplateOutlet="noRecordsTemplate;"
      ></ng-container>
    </h4>
</ng-template>
</kendo-grid>
